import { render } from "./search-communicate.vue?vue&type=template&id=9a6d6e32"
import script from "./search-communicate.js?vue&type=script&lang=js"
export * from "./search-communicate.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__